// Importing necessary libraries and components
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";

// Defining custom styles using Material-UI's makeStyles
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex", // Display chips in a flex container
    justifyContent: "flex-end", // Align chips to the right
    flexWrap: "wrap", // Allow chips to wrap to the next line if needed
    listStyle: "none", // Remove default list styling
    padding: theme.spacing(0.5), // Add padding around the container
    margin: 0, // Remove default margin
  },
  chip: {
    margin: theme.spacing(0.5), // Add margin around each chip
  },
}));

// Functional component to render search chips
function SearchChips({
  searchValues, // Array of search values to display as chips
  handleDeleteChip, // Function to handle chip deletion
}) {
  const classes = useStyles(); // Apply custom styles

  return (
    <Paper elevation={0} component="ul" className={classes.root}>
      {/* Map through searchValues and render a Chip for each value */}
      {searchValues.map((chip, index) => {
        const isDateChip = chip.startsWith("Date");
        return (
          <li key={index}>
            <Chip
              label={chip}
              onDelete={isDateChip ? undefined : () => handleDeleteChip(chip)}
              className={classes.chip}
            />
          </li>
        );
      })}
    </Paper>
  );
}

// Defining prop types for the component
SearchChips.propTypes = {
  searchValues: PropTypes.arrayOf(PropTypes.string), // Array of strings for chip labels
  handleDeleteChip: PropTypes.func, // Function to handle chip deletion
};

// Exporting the component as the default export
export default SearchChips;
